module.exports = __webpack_public_path__ + "static/aws_apn-40e202f0e7a07d9631abbd0bd2e74be1.png";